(function () {
  var root = document.querySelector('[data-mb-pdp]');
  if (!root || root._on) return; root._on = 1;
  var track = root.querySelector('[data-track]');
  var thumbs = root.querySelectorAll('[data-go]');
  var dots = root.querySelectorAll('.mb-gal__dots i');
  function mark(i) {
    thumbs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i); });
    dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { var i = Number(t.dataset.go); track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); mark(i); });
  });
  if (track) track.addEventListener('scroll', function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, { passive: true });

  var dlg = root.querySelector('[data-zoom-dialog]'), zimg = root.querySelector('[data-zoom-img]');
  root.querySelectorAll('[data-zoom]').forEach(function (b) {
    b.addEventListener('click', function () { if (!dlg || !dlg.showModal) return; zimg.src = b.dataset.zoom; dlg.showModal(); });
  });
  if (dlg) {
    root.querySelector('[data-zoom-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target === zimg) dlg.close(); });
  }

  var eta = root.querySelector('[data-eta]');
  if (eta) {
    var add = function (n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; } return d; };
    var f = { day: 'numeric', month: 'short' };
    try { eta.textContent = add(Number(eta.dataset.min || 3)).toLocaleDateString('en-GB', f) + ' – ' + add(Number(eta.dataset.max || 5)).toLocaleDateString('en-GB', f); } catch (e) {}
  }

  var form = root.querySelector('[data-mb-form]');
  if (!form) return;
  var idInput = form.querySelector('[data-variant-input]');
  var qty = form.querySelector('[data-qty]');
  form.querySelectorAll('[data-q]').forEach(function (b) {
    b.addEventListener('click', function () {
      qty.value = Math.max(1, Math.min(Number(qty.max || 99), Number(qty.value || 1) + Number(b.dataset.q)));
    });
  });
  form.querySelectorAll('[data-variant]').forEach(function (b) {
    b.addEventListener('click', function () {
      form.querySelectorAll('[data-variant]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      idInput.value = b.dataset.variant;
      var p = root.querySelector('[data-price]');
      p.innerHTML = (b.dataset.compare ? '<s>' + b.dataset.compare + '</s>' : '') + '<strong>' + b.dataset.price + '</strong>';
      var sp = root.querySelector('[data-sticky-price]'); if (sp) sp.textContent = b.dataset.price;
      var u = new URL(location.href); u.searchParams.set('variant', b.dataset.variant); history.replaceState(null, '', u);
    });
  });
  function items() { return [{ id: Number(idInput.value), quantity: Math.max(1, Number(qty.value || 1)) }]; }
  function busy(btn, on) { if (!btn) return; if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy'); }
  form.addEventListener('submit', function (e) {
    if (!window.MBCart) return;
    e.preventDefault();
    var btn = form.querySelector('[data-atc]'); busy(btn, true);
    window.MBCart.add(items()).catch(function () {}).finally(function () { busy(btn, false); });
  });
  var buy = form.querySelector('[data-buy]');
  if (buy) buy.addEventListener('click', function () {
    busy(buy, true);
    if (!window.MBCart) { form.submit(); return; }
    window.MBCart.add(items(), { checkout: true }).catch(function () { busy(buy, false); });
  });

  var sticky = root.querySelector('[data-sticky]'), atc = form.querySelector('[data-atc]');
  if (sticky && atc && 'IntersectionObserver' in window) {
    var sbtn = sticky.querySelector('[data-sticky-atc]');
    new IntersectionObserver(function (en) {
      var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', String(!show));
      sbtn.tabIndex = show ? 0 : -1;
    }).observe(atc);
    sbtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else atc.click(); });
  }
})();
